<template>
  <a
      v-if="data && data.id"
      class="card-link"
      @click.prevent="handleClick"
  >
    <div class="card">

      <!-- =========================
           左侧文字区域
           ========================= -->
      <div class="card-info">

        <!-- 标题 -->
        <div class="header">
          <h5 class="card-title">
            {{ data.name }}
          </h5>

          <!-- 日期 + 收藏 -->
          <div class="ri">
            <i class="bi bi-clock riqiziti">
                            <span>
                                &nbsp;{{ formatDate(data.createTime) }}&nbsp;&nbsp;
                            </span>
            </i>

            <i class="bi bi-star-fill riqiziti">
                            <span>
                                &nbsp;{{ data.collectCount }}{{ data.collection }}
                            </span>
            </i>
          </div>
        </div>

        <!-- history -->
        <div class="content">
          <p
              class="card-text"
              :title="data.history"
          >
            {{ getMiddleHistory(data.history) }}
          </p>
        </div>

        <!-- 地区 -->
        <div class="footer">
                    <span class="bi bi-send-fill weiz changlv">
                        &nbsp;{{ data.province }}-{{ data.city }}
                    </span>
        </div>

      </div>


      <!-- =========================
           右侧图片
           ========================= -->
      <div class="image-area">
        <div class="image-container">
          <img
              :src="data.img"
              alt="..."
              class="card-img"
          >
        </div>
      </div>

    </div>
  </a>
</template>


<script>
export default {

  name: "ZhaiCard",

  props: {
    data: {
      type: Object,
      required: true
    }
  },

  methods: {

    /**
     * 点击卡片
     */
    handleClick() {

      this.$emit('click');

      this.$router.push({
        name: 'detailPage2',
        query: {
          id: this.data.id
        }
      });

    },


    /**
     * 日期
     */
    formatDate(time) {

      if (!time) {
        return '';
      }

      return String(time).substring(0, 10);

    },


    /**
     * history
     *
     * 超过19个字符：
     *
     * 从全文正中间截取19个字符
     *
     * 显示：
     *
     * ...xxxxxxxxxxxxxxxxxxx...
     *
     * 然后由CSS根据宽度自然换成两行
     */
    getMiddleHistory(text) {

      if (!text) {
        return '';
      }

      // 去掉换行、多余空格
      const cleanText = String(text)
          .replace(/\s+/g, ' ')
          .trim();

      const chars = Array.from(cleanText);

      const showLength = 24;


      // 19个字以内直接完整显示
      if (chars.length <= showLength) {

        return chars.join('');

      }


      // 计算正中间的开始位置
      const start = Math.floor(
          (chars.length - showLength) / 2
      );


      // 正中间截取19个字
      const middleText = chars
          .slice(
              start,
              start + showLength
          )
          .join('');


      // 前后添加省略号
      return `...${middleText}...`;

    }

  }

};
</script>


<style scoped>

/* =========================
   外层
   ========================= */

.card-link {

  display: block;

  width: 100%;

  text-decoration: none;

  color: inherit;

}


/* =========================
   整张卡片
   ========================= */

.card {

  width: 100%;

  height: 155px;

  box-sizing: border-box;

  border: none;

  border-radius: 6px;

  background: #ffffff;

  /*
   * 最关键
   *
   * 左文字 + 右图片
   */
  display: flex;

  flex-direction: row-reverse;

  align-items: stretch;

  overflow: hidden;

}


/* =========================
   左侧文字
   ========================= */

.card-info {

  /*
   * 自动占满图片左边的全部空间
   */
  flex: 1;

  /*
   * 解决 flex 子元素不能正常缩小的问题
   */
  min-width: 0;

  height: 155px;

  box-sizing: border-box;

  padding:

      10px
      8px
      8px
      4px;

  display: flex;

  flex-direction: column;

}


/* =========================
   标题
   ========================= */

.header {

  flex-shrink: 0;

}


.card-title {

  margin: 0 0 6px 0;

  padding: 0;

  font-size: 1rem;

  font-weight: 500;

  line-height: 1.4;

  /*
   * 标题一行
   */
  white-space: nowrap;

  overflow: hidden;

  text-overflow: ellipsis;

}


/* =========================
   日期 / 收藏
   ========================= */

.ri {

  display: flex;

  align-items: center;

  height: 20px;

  font-size: 0.8rem;

  color: #888;

  white-space: nowrap;

}


.riqiziti {

  display: inline-flex;

  align-items: center;

  font-style: normal;

  font-size: 0.8rem;

  margin-right: 4px;

}


.ri i + i {

  margin-left: 4px;

}


/* =========================
   history
   ========================= */

.content {

  /*
   * 占用标题和地区之间所有剩余空间
   */
  flex: 1;

  min-height: 0;

  display: flex;

  align-items: center;

  justify-content: flex-start;

  overflow: hidden;

}


.card-text {

  width: 100%;

  margin: 0 !important;

  padding: 0;

  font-size: 0.9rem !important;

  line-height: 1.6;

  color: #333;

  /*
   * 左对齐
   */
  text-align: left;

  /*
   * 允许自动换行
   */
  white-space: normal;

  word-break: break-all;

  overflow-wrap: break-word;

  /*
   * 最多给两行高度
   */
  max-height: 2.9rem;

  overflow: hidden;

}


/* =========================
   底部地区
   ========================= */

.footer {

  flex-shrink: 0;

  height: 24px;

  display: flex;

  align-items: center;

  overflow: hidden;

}


.weiz {

  font-size: 0.9rem;

  white-space: nowrap;

}


.changlv {

  color: #18b371 !important;

}


/* =========================
   右侧图片
   ========================= */

.image-area {

  /*
   * 图片固定115px
   *
   * 左侧 card-info 自动使用剩余空间
   */
  flex:

      0
      0
      115px;

  width: 115px;

  height: 155px;

  display: flex;

  justify-content: center;

  align-items: center;

  box-sizing: border-box;

}


/* 图片容器 */
.image-container {

  width: 99px;

  height: 132px;

  display: flex;

  justify-content: center;

  align-items: center;

  overflow: hidden;

  border-radius: 4px;

}


/* 图片 */
.card-img {

  display: block;

  width: 100%;

  height: 100%;

  object-fit: cover;

}


/* =========================
   比较窄的手机
   ========================= */

@media (max-width: 400px) {

  /*
   * 小屏幕稍微缩小右边图片
   * 给左侧文字更多空间
   */
  .image-area {

    flex-basis: 105px;

    width: 105px;

  }


  .image-container {

    width: 91px;

    height: 121px;

  }


  .card-info {

    padding-left: 10px;

    padding-right: 5px;

  }


  .card-title {

    font-size: 0.95rem;

  }


  .card-text {

    font-size: 0.85rem !important;

  }


  .ri,
  .riqiziti {

    font-size: 0.75rem;

  }


  .weiz {

    font-size: 0.85rem;

  }

}

</style>